import { useEffect, useState } from "react";

/**
 * Full-viewport door-knocker splash shown once per browser tab.
 * The mark fades in, does two subtle "knock" bumps, then the whole
 * overlay fades out. Total time ~1.4s; users on repeat visits skip it
 * (session-scoped) so the app feels fast after the first impression.
 */
export function SplashScreen() {
  const [phase, setPhase] = useState(() => (typeof window !== "undefined" && sessionStorage.getItem("jk_splash_seen") ? "gone" : "in"));

  useEffect(() => {
    if (phase === "gone") return;
    sessionStorage.setItem("jk_splash_seen", "1");
    const t1 = setTimeout(() => setPhase("out"), 1100);
    const t2 = setTimeout(() => setPhase("gone"), 1500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [phase]);

  if (phase === "gone") return null;

  return (
    <div
      data-testid="brand-splash"
      className={`jk-splash ${phase === "out" ? "jk-splash-out" : ""}`}
      aria-hidden="true"
    >
      <img
        src="/logo-icon.png"
        alt=""
        className="jk-splash-mark"
        width={128}
        height={128}
      />
    </div>
  );
}
